import { createElementBlock as a, openBlock as c, createElementVNode as l } from "vue";
import o from "./index289.js";
const t = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function r(s, e, f, i, m, p) {
  return c(), a("svg", n, e[0] || (e[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#FFF9D5",
        d: "M27.695 16.177C28.267 11.022 32.541 7 37.79 7c0 5.702 4.572 10.328 10.21 10.328 0 3.453-1.694 6.495-4.267 8.368L34 24.5l-6.305-8.323Z"
      }),
      l("path", {
        fill: "#F7F6EF",
        d: "M38.704 23.721c-1.168 0-2.268.243-3.23.73-.721-4.809-4.846-8.504-9.797-8.504-5.399 0-9.797 4.39-9.937 9.828-3.23.419-5.74 3.205-5.74 6.658-.002 3.695 2.952 6.693 6.598 6.693h22.104c4.193 0 7.597-3.45 7.597-7.703 0-4.252-3.404-7.702-7.595-7.702Z"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M37.79 5.75c.69 0 1.25.56 1.25 1.25 0 5.015 4.016 9.078 8.96 9.078.69 0 1.25.56 1.25 1.25 0 3.265-1.363 6.302-3.673 8.463a8.974 8.974 0 0 1 1.972 5.632c0 4.939-3.96 8.953-8.847 8.953H16.598c-4.34 0-7.85-3.561-7.848-7.943 0-3.607 2.341-6.67 5.621-7.642l.19-.054.02-.163c.7-5.474 5.259-9.728 10.803-9.873l.293-.004c.334 0 .666.015.994.045 1.167-5.185 5.72-8.992 11.12-8.992ZM25.677 17.197c-4.702 0-8.565 3.832-8.687 8.61a1.25 1.25 0 0 1-1.09 1.208c-2.648.343-4.65 2.635-4.65 5.419-.002 3.008 2.397 5.442 5.348 5.442h22.104c3.5 0 6.347-2.888 6.347-6.453 0-1.828-.75-3.478-1.95-4.652a1.208 1.208 0 0 1-.376-.34 6.26 6.26 0 0 0-4.019-1.46c-.987 0-1.891.203-2.666.595a1.25 1.25 0 0 1-1.8-.93c-.538-3.584-3.215-6.416-6.61-7.213a.401.401 0 0 1-.07-.003 1.252 1.252 0 0 1-.312-.076 8.369 8.369 0 0 0-1.57-.147ZM36.615 8.33l-.115.015c-3.614.535-6.546 3.281-7.381 6.904a11.254 11.254 0 0 1 7.207 7.341l.054.185.166-.045a8.778 8.778 0 0 1 1.787-.25l.371-.008c1.877 0 3.617.592 5.048 1.602a9.073 9.073 0 0 0 2.872-5.233l.05-.34-.112-.012c-5.18-.656-9.285-4.806-9.933-10.037l-.014-.122Zm-22.684 38.7a1.25 1.25 0 0 1 2.045 1.431l-.079.112-.47.6a1.25 1.25 0 0 1-2.045-1.432l.078-.112.47-.6Zm13.033 0a1.25 1.25 0 0 1 2.045 1.431l-.078.112-.471.6a1.25 1.25 0 0 1-2.045-1.432l.078-.112.471-.6Zm14.218 0a1.25 1.25 0 0 1 2.045 1.431l-.078.112-.471.6a1.25 1.25 0 0 1-2.045-1.432l.078-.112.471-.6Zm-18.957 6a1.25 1.25 0 0 1 2.045 1.431l-.079.112-.47.6a1.25 1.25 0 0 1-2.046-1.432l.079-.112.47-.6Zm11.848 0a1.25 1.25 0 0 1 2.045 1.431l-.078.112-.471.6a1.25 1.25 0 0 1-2.045-1.432l.078-.112.471-.6Z"
      })
    ], -1)
  ]));
}
const _ = /* @__PURE__ */ o(t, [["render", r]]);
export {
  _ as default
};
